export const LOCAL_STORAGE_ELEMENT_ID = 'LOCAL_STORAGE_ELEMENT_ID';

// window.showElementId = () => {
//   window.localStorage.setItem(LOCAL_STORAGE_ELEMENT_ID, 1);
// }

// window.hideElementId = () => {
//   window.localStorage.removeItem(LOCAL_STORAGE_ELEMENT_ID);
// }

export const getElementID = (pageName: string, elementName: string): string => {
  const id: string = pageName + (elementName ? '-' + elementName : '');
  if (window.localStorage.getItem(LOCAL_STORAGE_ELEMENT_ID)) {
    console.log('Element ID: document.querySelector(\'#' + id + '\');');
  }
  return id;
}

export const getMergedClassNames = (allClassNames: string[]): string => {
  let classes: string[] = [];
  allClassNames.map(className => {
    if (typeof className === 'string' && className.length > 0) {
      classes.push(className);
    }
    return className;
  });
  return classes.join(' ');
}